import { useEffect, useState } from "react";
import { api, fmtDate } from "../lib/api";
import { PageHeader, Card } from "../components/PageHeader";
import { RoleBadge } from "../components/Badges";

export default function Activity() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/activities", { params: { limit: 300 } }).then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="activity-page">
      <PageHeader title="Activity Log" subtitle="A complete audit trail of actions in the CRM." />
      <Card className="p-6">
        <ol className="relative border-l border-slate-200 ml-2 space-y-5">
          {items.map((a) => (
            <li key={a.id} className="ml-5" data-testid={`activity-item-${a.id}`}>
              <div className="absolute -left-1.5 mt-1.5 h-3 w-3 rounded-full bg-emerald-500 ring-4 ring-emerald-50" />
              <div className="flex flex-wrap items-center gap-2 text-sm">
                <span className="font-semibold">{a.user_name}</span><RoleBadge role={a.user_role} />
                <span className="text-xs uppercase tracking-wider text-slate-400">{a.action.replace(/_/g, " ")}</span>
              </div>
              <div className="mt-0.5 text-sm text-slate-700">{a.details}{a.lead_name && <span className="text-slate-500"> · {a.lead_name}</span>}</div>
              <div className="text-xs text-slate-400">{fmtDate(a.created_at)}</div>
            </li>
          ))}
          {!items.length && <div className="ml-5 text-slate-500" data-testid="activity-empty">No activity yet.</div>}
        </ol>
      </Card>
    </div>
  );
}
